const AcompanharEnvio = () => import('@/views/AcompanharEnvio.vue');
const AcompanharEnvioNaoLogado = () => import('@/views/AcompanharEnvioNaoLogado.vue');

const routes = [
  {
    path: '/acompanhar-envio/:compraId',
    name: 'acompanhar-envio',
    component: AcompanharEnvio,
    props: route => ({
      compraId: +route.params.compraId,
    }),
    meta: {
      title: 'Acompanhar envio',
    },
  },
  {
    path: '/rastrear-envio/:codigoRastreio',
    name: 'acompanhar-envio-nao-logado',
    component: AcompanharEnvioNaoLogado,
    props: route => ({
      namePath: route.name,
      codigoRastreio: route.params.codigoRastreio,
    }),
    meta: {
      public: true,
      disabledChatbox: true,
      title: 'Acompanhar envio',
    },
  },
];

export default routes;
